import { Button, Form, InputGroup, ListGroup, Stack } from "react-bootstrap";
import { MdCheck, MdClose, MdDelete, MdEdit } from "react-icons/md";
import styles from './style.module.css';
import { useState } from "react";
import { HttpData, HttpNoData } from "../../../../Core";

export default function RangeThicknessEdit({ rangeThickness, onDeleted, jwt }) {

    const [isEdit, setIsEdit] = useState(false);

    const [thickness, setThickness] = useState(rangeThickness.thickness);
    const [percent, setPercent] = useState(rangeThickness.percent);

    const updateAsync = async () => {

        const sizesResponse = await HttpData(`/api/v1/calculateOrderCost/productRangeThickness/${rangeThickness.id}`, 'PUT', jwt, {
            thickness: +thickness,
            percent: +percent,
            productId: +rangeThickness.productId
        });

        if (sizesResponse.statusSuccessful) {
            rangeThickness.thickness = +thickness;
            rangeThickness.percent = +percent;
            setIsEdit(false);
        }
        else alert('Не получилось обновить')
    }

    const deleteAsync = async () => {

        const sizesResponse = await HttpNoData(`/api/v1/calculateOrderCost/productRangeThickness/${rangeThickness.id}`, 'DELETE', jwt);

        if (sizesResponse.statusSuccessful)
            onDeleted();
        else alert('Не получилось удалить')
    }

    if (isEdit)
        return <ListGroup.Item>
            <div className={styles.listItem}>
                <Stack direction="horizontal" gap={1}>
                    <InputGroup>
                        <Form.Control
                            value={thickness}
                            onChange={(e) => setThickness(e.target.value)}
                            type="number"
                        />
                        <InputGroup.Text>мм</InputGroup.Text>
                        <Form.Control
                            value={percent}
                            onChange={(e) => setPercent(e.target.value)}
                            type="number"
                        />
                        <InputGroup.Text>%</InputGroup.Text>
                    </InputGroup>
                    <Button variant="success" onClick={updateAsync}>
                        <MdCheck />
                    </Button>
                    <Button variant="danger" onClick={() => setIsEdit(false)}>
                        <MdClose />
                    </Button>
                </Stack>
            </div>
        </ListGroup.Item>

    return <ListGroup.Item>
        <div className={styles.listItem}>
            <span>{rangeThickness.thickness}мм</span>
            <span>{rangeThickness.percent}%</span>
            <Stack direction="horizontal" gap={1}>
                <Button variant="warning" onClick={() => setIsEdit(true)}>
                    <MdEdit />
                </Button>
                <Button variant="danger" onClick={deleteAsync}>
                    <MdDelete />
                </Button>
            </Stack>
        </div>
    </ListGroup.Item>
};